/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { generateOnHandlerMethods, extendsAccesibility } from "./utils";
import { ENV_NAME } from "@gcloud-npm/utils.enums.environment";

let currentEnv = process.env.NEXT_PUBLIC_ENV_NAME;

const appendHost = (href) => {
  let safeHref = String(href || "");
  let myEnv2Use = currentEnv;

  if (safeHref.indexOf("areaprivada") > -1) {
    myEnv2Use = "prod";
  }

  if (
    safeHref.indexOf("www.") === -1 &&
    safeHref.indexOf("http") === -1 &&
    safeHref.indexOf("//") === -1
  ) {
    switch (myEnv2Use) {
      case ENV_NAME.LOCAL:
        safeHref = `http://127.0.0.1:8089${safeHref}`;
        break;
      case ENV_NAME.CODE:
      case ENV_NAME.CERT:
        safeHref = `https://www.movistar.es.cert${safeHref}`;
        break;
      case ENV_NAME.INTE:
        safeHref = `https://www.movistar.es.inte${safeHref}`;
        break;
      case ENV_NAME.DEV_SSR:
        safeHref = `https://www.movistar.es/develop${safeHref}`;
        break;
      case ENV_NAME.QA_SSR:
        safeHref = `https://www.movistar.es/qa${safeHref}`;
        break;
      case ENV_NAME.PREPROD:
        safeHref = `https://www.movistar.es.telefonica`;
        break;
      default:
      case ENV_NAME.PROD:
        safeHref = `https://www.movistar.es${safeHref}`;
        break;
    }
  }

  if (
    safeHref &&
    safeHref.indexOf("#") === -1 &&
    safeHref.indexOf("?") === -1 &&
    safeHref[safeHref.length - 1] !== "/"
  ) {
    safeHref = `${safeHref}/`;
  }
  return safeHref;
};

const getReadyLinkForDev = (href, preserveBasePath) => {
  let devLink = href;
  const projectBasePath = `${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}`;

  // eliminamos el basename del proyecto
  if (
    !preserveBasePath &&
    projectBasePath !== "/" &&
    href.indexOf("http") === -1 &&
    href.indexOf("//") === -1
  ) {
    devLink = href.replace(`${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}`, "");
  }

  if (!devLink) {
    devLink = "/";
  }

  if (
    devLink &&
    devLink.indexOf("#") === -1 &&
    devLink.indexOf("?") === -1 &&
    devLink.indexOf(".") === -1 &&
    devLink[devLink.length - 1] !== "/"
  ) {
    devLink = `${devLink}/`;
  }
  if (preserveBasePath) {
    devLink = `${projectBasePath}${devLink}`;
  }

  return devLink;
};

const checkIfHasHrefOperators = (href) => {
  const safeHref = String(href || "");
  const OPERATORS = ["tel:", "mailto:"];
  return OPERATORS.some(op => safeHref.includes(op));
};

const checkIsExternal = (link = "", forceExternal) => {
  const safeLink = String(link || "");
  const EXTERNAL_PATTERNS = ["http", "areaprivada"];
  return forceExternal || EXTERNAL_PATTERNS.some(pattern => safeLink.includes(pattern));
};


/**
 * @name CustomLinkReact
 * @description atomic component
 * @see {@link https://nextjs.org/docs/api-reference/next/link}
 * @param {LinkProps} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */

const CustomLinkReact = ({
  id,
  children,
  className,
  href,
  taggingInfo,
  title: cmpTitle,
  target,
  ariaLabel: cmpAriaLabel,
  screenReadable: cmpScreenRedable,
  style,
  onClick,
  buttonParent,
  buttonTypeHtml,
  disabled,
  cyData,
  external,
  preserveBasePath,
}) => {
  let currentClassName = `next-link${className ? ` ${className}` : ""}`;
  const finalCssName = !children
    ? `${currentClassName} nextLinkOverBox`
    : currentClassName;

  const { title, ariaLabel, ariaHidden } = extendsAccesibility({
    cmpTitle,
    cmpAriaLabel,
    cmpScreenRedable,
    taggingInfo,
  });

  /* wrapeamos funciones ejecutadoras */
  const {
    newOnClick: onClickHandler,
    newOnKeyDown: onKeyDownHandler,
    newOnMouseDown: onMouseDownHandler,
  } = generateOnHandlerMethods({
    onClick,
    taggingInfo,
    disabled,
  });

  // 0) vemos si tiene href sino tiene solo es un elemento para taggear (TODO)
  if (!href && onClick) {
    return (
      <button
        id={id || null}
        type={buttonTypeHtml}
        className={finalCssName}
        tabIndex={0}
        aria-label={ariaLabel}
        aria-hidden={ariaHidden}
        title={title}
        onClick={onClickHandler}
        onKeyDown={onKeyDownHandler}
        onMouseDown={onMouseDownHandler}
        disabled={disabled}
        style={style}
        data-cy={cyData}
      >
        {buttonParent && <div className="hover-layer" />}
        {children}
      </button>
    );
  } else if (href) {
    const hasOperators = checkIfHasHrefOperators(href);
    const isExternal = checkIsExternal(href, external);
  
    href = appendHost(href);
    // "2 ) logica de link as usual"
    // if (
    //   (currentEnv === ENV_NAME.LOCAL && !hasOperators && !external) ||
    //   (currentEnv === ENV_NAME.DEV_SSR && !hasOperators && !external) ||
    //   (currentEnv === ENV_NAME.QA_SSR && !hasOperators && !external)
    // ) {
    //   href = getReadyLinkForDev(href, preserveBasePath);
    // }
  
    if (isExternal) {
      return (
        <a
          id={id || null}
          className={finalCssName}
          tabIndex={0}
          aria-label={ariaLabel}
          aria-hidden={ariaHidden}
          title={title}
          href={disabled ? "" : href}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : ""}
          onClick={onClickHandler}
          onKeyDown={onKeyDownHandler}
          onMouseDown={onMouseDownHandler}
          disabled={disabled}
          style={style}
          data-cy={cyData}
        >
          {buttonParent && <div className="hover-layer" />}
          {children}
        </a>
      );
    }
  
    return (
      <Link
        id={id || ""}
        to={disabled ? "" : href}
        className={finalCssName}
        tabIndex={0}
        aria-label={ariaLabel}
        aria-hidden={ariaHidden}
        title={title}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : ""}
        onClick={onClickHandler}
        onKeyDown={onKeyDownHandler}
        onMouseDown={onMouseDownHandler}
        disabled={disabled}
        style={style}
        data-cy={cyData}
      >
        {buttonParent && <div className="hover-layer" />}
        {children}
      </Link>
    );
  }
  return null;

};

CustomLinkReact.propTypes = {
  /**
   * Id del componente.
   */
  id: PropTypes.string,
  /**
   * Enlace al que se quiere redireccionar.
   */
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Función que se quiere ejecutar al clickar el componente.
   */
  onClick: PropTypes.func,
  /**
   * Clase para estilos adicionales.
   */
  className: PropTypes.string,
  /**
   * Información para el tagueado del componente.
   */
  taggingInfo: PropTypes.object.isRequired,
  /**
   * Comportamiento para cuando se utiliza href, por defecto
   * es _self pero se puede cambiar a _blank si se quiere que
   * el enlace se abra en una nueva pestaña.
   */
  target: PropTypes.string,
  /**
   * Texto que se muestra al pasar el ratón por encima del componente.
   *  Primero utiliza taggingInfo.componentContent y si es nulo utiliza este atributo.
   */
  title: PropTypes.string,
  /**
   * Proporciona una descripción
   * precisa y concisa del contenido del elemento para usuarios de
   * tecnologías de asistencia, como lectores de pantalla, que
   * no pueden ver o interpretar el contenido visual.
   * Primero utiliza taggingInfo.componentContent y si es nulo utiliza este atributo.
   */
  ariaLabel: PropTypes.string,
  /**
   * Deshabilita el componente (solo en ocasiones que se utiliza onClick).
   */
  disabled: PropTypes.bool,
  /**
   *  Cuando se establece en true, indica que el elemento no debe ser presentado visualmente o leído por el lector de pantalla.
   */
  screenReadable: PropTypes.bool,
  /**
   * Distintas propiedades para enlaces en relativo que se consideren internos a la app.
   */
  buttonTypeHtml: PropTypes.string,
  /**
   * Parámetros para componente button (ignorar).
   */
  buttonParent: PropTypes.bool,
  /**
   * Parámetros para componente button (ignorar).
   */
  style: PropTypes.object,
  cyData: PropTypes.string,
  external: PropTypes.bool,
  preserveBasePath: PropTypes.bool,
};

CustomLinkReact.defaultProps = {
  id: null,
  className: "",
  target: "_self",
  screenReadable: true,
  disabled: false,
  onClick: null,
  buttonTypeHtml: "button",
  buttonParent: false,
  style: {},
  cyData: "",
  external: false,
  preserveBasePath: false,
};

export default CustomLinkReact;
